// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

Array.prototype.remove = function (from, to) {
    var rest = this.slice((to || from) + 1 || this.length);
    this.length = from < 0 ? this.length + from : from;
    return this.push.apply(this, rest);
};

// http://stackoverflow.com/questions/5767325/remove-specific-element-from-an-array
Array.prototype.destroy = function (obj) {
    // Return null if no objects were found and removed
    var destroyed = null;
    for (var i = 0; i < this.length; i++) {
        // Use while-loop to find adjacent equal objects
        while (this[i] === obj) {
            // Remove this[i] and store it within destroyed
            destroyed = this.splice(i, 1)[0];
        }
    }
    return destroyed;
};

var escape = encodeURIComponent;

function param(obj, traditional) {
    var params = [];
    params.add = function (k, v) { this.push(escape(k) + '=' + escape(v)); };
    for (var key in obj)
        params.add(key, obj[key]);
    return params.join('&').replace(/%20/g, '+');
};

function transform(tdata) {
    var tmp = param(tdata);
    return tmp;
};

var EmailEditControllerBase = function (typeString, $scope, $rootScope, $routeParams, DocumentEmailTemplate, EmailTemplatePlaceholder, gettext, gettextCatalog) {
    $scope.template = DocumentEmailTemplate.get({ emailType: typeString });
    $scope.template.EmailType = typeString;
    $scope.placeholders = EmailTemplatePlaceholder.query();
    $scope.addLanguage = function (newKey) {
        if ($scope.template.Subject[newKey])
            return; // already exists
        $scope.template.Subject[newKey] = gettextCatalog.getString(gettext('Subject'));
    };

    $scope.removeLanguage = function (key) {
        $scope.yesCancel(gettextCatalog.getString(gettext("Delete Language")), gettextCatalog.getString(gettext("Are you sure?")), function () {
            delete $scope.template.Subject[key];
            delete $scope.template.HtmlText[key];
        });
    };

    $scope.save = function () {
        if ($scope.template.Id !== '000000000000000000000000')
            $scope.template.$update({ id: $routeParams.templateId }, function () { $scope.notifySuccess(); });
        else
            $scope.template.$save({}, function () { $scope.notifySuccess(); });
    };
};

/* Controllers */
angular.module('iteroControllers', [])
    .controller('NavController', NavController);